<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <i-input
          prefix="ios-search"
          placeholder="请输入活性炭设备别名查询"
          v-model="search.name"
          style="width: auto; margin-left: 1em"
        />
        <i-button type="default" @click="getData" style="margin-left: 1em"
          >搜索</i-button
        >
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page
        :total="table.total"
        show-sizer
        @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)"
        style="text-align: right; margin-top: 1em"
      />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="站点编号" prop="mn">
          <Select
            clearable
            @on-change="getDevice($event)"
            v-model="formValidate.mn"
            style="width: 100px; margin-right: 20px; text-align: center"
          >
            <Option v-for="prop in siteList" :key="prop.id" :value="prop.mn">{{
              prop.name
            }}</Option>
          </Select>
        </FormItem>

        <FormItem label="绑定设备：" prop="siteDeviceId">
          <Select
            v-model="formValidate.siteDeviceId"
            clearable
            style="width: 100px; margin-right: 20px; text-align: center"
          >
            <Option
              v-for="item in curDeviceList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="备注：" prop="remark">
          <i-input
            v-model="formValidate.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="此处写备注"
          ></i-input>
        </FormItem>

        <FormItem label="重量：" prop="weight">
          <i-input
            v-model="formValidate.weight"
            placeholder="请输入重量"
          ></i-input>
        </FormItem>
        <FormItem label="进风口浓度" prop="concentration">
          <i-input
            v-model="formValidate.concentration"
            placeholder="请输入进风口浓度"
          ></i-input>
        </FormItem>
        <FormItem label="风量" prop="airVolume">
          <i-input
            v-model="formValidate.airVolume"
            placeholder="请输入风量"
          ></i-input>
        </FormItem>
        <FormItem label="更换时间：" prop="data">
          <Row>
            <i-col span="11">
              <FormItem prop="reloadTime">
                <DatePicker
                  type="date"
                  placeholder="输入更换时间"
                  v-model="formValidate.reloadTime"
                ></DatePicker>
              </FormItem>
            </i-col>
          </Row>
        </FormItem>

        <FormItem label="坐标X轴" prop="locationX">
          <i-input
            v-model="formValidate.locationX"
            placeholder="请输入显示位置X轴"
          ></i-input>
        </FormItem>
        <FormItem label="坐标Y轴" prop="locationY">
          <i-input
            v-model="formValidate.locationY"
            placeholder="请输入显示位置Y轴"
          ></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{
          modal.title
        }}</i-button>
        <i-button style="margin-left: 1em" @click="modal.show = false"
          >取消</i-button
        >
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p
      :modalAlert="alert.show"
      title="警告提醒"
      content="确定要删除吗？"
      @cansel="alert.show = false"
      @makeSure="delData"
      :modal_loading="alert.loading"
    ></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
.content {
  width: 700px;
  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "站点名称",
            key: "siteName",
            align: "center",
          },
          {
            title: "绑定风机",
            key: "deviceName",
            align: "center",
          },
          {
            title: "活性炭重量(g)",
            key: "weight",
            align: "center",
          },
          {
            title: "进风口浓度(mg/m3)",
            key: "concentration",
            align: "center",
          },
          {
            title: "风量(m3/h)",
            key: "airVolume",
            align: "center",
          },
          {
            title: "剩余吸附量",
            key: "remainVolume",
            align: "center",
          },
          {
            title: "总去除量(g)",
            key: "vOCsVolume",
            align: "center",
          },
          {
            title: "更换时间",
            key: "reloadTime",
            align: "center",
            render: (h, params) => {
              return h("div", [h("span", {}, timeStamp(params.row.reloadTime))]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          mn: params.row.mn,
                          siteName: params.row.siteName, // 站点名称
                          siteDeviceId: params.row.siteDeviceId, // 绑定风机ID
                          deviceName: params.row.deviceName, // 绑定风机ID
                          reloadTime: timeStamp(
                            params.row.reloadTime,
                            "yyyy-MM-dd",true
                          ), //重置时间
                          weight: params.row.weight, //重量
                          concentration: params.row.concentration, // 进风口浓度
                          airVolume: params.row.airVolume, // 进口风量
                          //remainVolume: params.row.remainVolume, // 剩余吸附量
                          remark: params.row.remark, // 备注
                          //VOCsVolume: params.row.VOCsVolume, // 总去除量
                          locationX: params.row.locationX, // X轴
                          locationY: params.row.locationY, // Y轴
                        };
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false, // 切换启用状态loading
      },
      // 查询
      search: {
        name: null,
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加",
        companyShow: false, // 站点工艺图modal显示隐藏
      },
      // 表单数据
      formValidate: {
        mn: "",
        siteName: "",
        siteDeviceId: "",
        deviceName: "",
        reloadTime: "", //重置时间
        weight:"", //重量
        concentration: "", // 进风口浓度
        remark: "", // 备注
        airVolume: "", // 进口风量
        locationX: "", // X轴
        locationY: "", // Y轴
        //VOCsVolume: "",// 总去除量
        //remainVolume: "" // 剩余吸附量
      },
      // 验证
      ruleValidate: {
        remark: [{ required: true, message: "不能为空", trigger: "blur" }],
        //concentration: [{ required: true, message: "不能为空", trigger: "blur" }],
        //weight: [{ required: true,  message: "不能为空", trigger: "blur" }],
        //airVolume: [{ required: true, message: "不能为空", trigger: "blur"}],
        siteName: [{ required: true, message: "不能为空", trigger: "change"}],
        deviceName: [{ required: true, message: "不能为空", trigger: "change"}],
        reloadTime: [{ required: true, type: "date", message: "不能为空"}],
        siteDeviceId: [{ required: true, type: "number", message: "请选择风机", trigger: "change"}],
        mn: [{ required: true, type: "string", message: "请选择站点", trigger: "change"}],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: "",
      },
      // 枚举数据
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备列表
      curDeviceList: [], // 设备列表
      selectMN: "",
    };
  },
  components: {
    toolbar,
  },
  created() {
    this.getData(); // 数据初始化
    this.getSiteEnum();
    this.getDeviceEnum();
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {};
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getActivatedCharcoalList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search,
        },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getActivatedCharcoalDel({ content: { id: id } }, [
          "uuid",
          "company",
        ])
          .then((res) => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: "",
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员",
              });
            }
          })
          .catch((err) => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员",
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postActivatedCharcoalAdd({ content: params }, [
              "uuid",
              "company",
            ]).then((res) => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据...",
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员",
                });
              }
            });
          } else {
            this.$api.Deploy.postActivatedCharcoalEdit({ content: params }, [
              "uuid",
              "company",
            ]).then((res) => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据...",
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员",
                });
              }
            });
          }
        } else {
          this.$Message.warning("输入信息有误");
        }
      });
    },
    // 获取站点枚举值
    getSiteEnum() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then((res) => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
    // 获取rtu枚举值
    getDeviceEnum() {
      this.$api.Enum.getDeviceEnum(null, ["uuid", "company"]).then((res) => {
        if (res.code == 0) {
          this.deviceList = res.data;
          this.curDeviceList = res.data; 
        } else {
          this.$Notice.warning({
            title: "获取设备枚举失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
    // 表单操作 选择站点后获取设备
    getDevice(siteMn) {
      //console.log(siteMn);
      this.selectMN = siteMn;
      var arr = new Array();
      this.deviceList.forEach(function (item, index) {
        if (item.mn == siteMn) {
          arr.push(item);
        }
      });
      this.curDeviceList = arr;
    },
  },
};
</script>